import { Details } from '../Details/Details';
import { XButton } from '../XButton/XButton';
import { useContext } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import { hasPublisherHaveBackgroundImage } from '@/utils/publisher';
import { useIsMobile } from '@/hooks/useIsMobile';
import { useIsLandscape } from '@/hooks/useIsLandscape';

export const TopWrapper = () => {
  const context = useContext(CheckoutContext);
  const {
    boot,
    actions: { closeCheckout },
    template,
  } = context;
  const isMobile = useIsMobile();
  const landscape = useIsLandscape();
  const hasBackgroundImage = hasPublisherHaveBackgroundImage(boot?.checkoutTheme, template.type);
  // The landscape phone band is a mobile target (just laid out inside the
  // 40/60 split), so it must use the publisher's MOBILE asset — same as
  // portrait — not the desktop `backgroundImage`. `useIsMobile()` is false in
  // landscape, so check `isLandscape()` explicitly here.
  const useMobileAsset = isMobile || landscape;
  const backgroundImage = hasBackgroundImage
    ? useMobileAsset
      ? boot?.checkoutTheme?.mobileBgImage || boot?.checkoutTheme?.backgroundImage
      : boot?.checkoutTheme?.backgroundImage
    : undefined;

  return (
    <div
      className="flex flex-col items-center justify-center shrink-0 md:w-2/5 md:justify-start bg-cover bg-center bg-top md:h-full landscape:w-[44%] landscape:h-[100dvh] landscape:justify-start"
      style={backgroundImage ? { backgroundImage: `url(${backgroundImage})` } : undefined}
    >
      {isMobile && !landscape && (
        <XButton
          onClick={() => closeCheckout(context)}
          // Over the hero band the X self-contrasts to white; only hand it the
          // publisher textColor when there's no background image behind it.
          style={hasBackgroundImage ? undefined : { color: boot?.checkoutTheme?.textColor }}
        />
      )}
      <Details />
    </div>
  );
};
